import { CheckboxItemCombinedProps } from './types';

const usePresenter = (props: CheckboxItemCombinedProps): CheckboxItemCombinedProps => {
  return props;
};

export default usePresenter;
